// The dashboard's one address (Terraform: admin_dashboard_domain, the contract
// test keeps the two equal). Firebase Hosting serves every site on its default
// domains as well, which cannot be switched off: a visit there goes to the
// address instead, path, query and fragment kept.
export const ADMIN_HOST = "pulse.chat.gateway.one";

const DEFAULT_DOMAIN_SUFFIXES = [".web.app", ".firebaseapp.com"];

/** Where `location` should go instead of where it is, or null when it is the
 * address itself or a local one. */
export function canonicalUrl(
  location: Pick<Location, "hostname" | "pathname" | "search" | "hash">,
): string | null {
  const host = location.hostname.toLowerCase();
  if (!DEFAULT_DOMAIN_SUFFIXES.some((suffix) => host.endsWith(suffix))) return null;
  return `https://${ADMIN_HOST}${location.pathname}${location.search}${location.hash}`;
}
